/**
 * Created by ianva on 16/7/7.
 */


var React = require('react');

var ReactDOM = require('react-dom');

var moment = require('moment');

var _ = require('underscore');

var $ = require('jquery');

var { PropTypes } = require('react');


var {object2class} = require("../util/clazz");

var NOOP = function () { }


var Dialog = React.createClass({
    displayName: "Dialog",
    propTypes: {
        /**
         * 是否打开 dialog
         */
        isOpen: PropTypes.bool,
        /**
         * 标题
         */
        title: PropTypes.string,
        /**
         * 关闭事件
         */
        onClose: PropTypes.func
    },
    childContextTypes: {

        close: PropTypes.func

    },
    getDefaultProps(){

        return {
            onClose: NOOP
        }
    },
    getChildContext: function() {
        return {
            close: this.close,
        };
    },
    componentDidMount(){


        this.containerEl = document.createElement('div');

        document.body.appendChild( this.containerEl );

        this.componentDidUpdate();

    },
    componentDidUpdate(){

        var className = object2class({
            'mod-dialog-full': true,
            'is-open': this.state.isOpen
        });

        ReactDOM.render(
            <div className={ className }>
                <div className="hd">
                    <h3>
                        {this.props.title}
                        <i className="icon-m-indicator-x-l close" onClick={ this.close }></i>
                    </h3>
                </div>
                <div className="bd">
                    { this.props.children }
                </div>
            </div>
            ,this.containerEl)
    },
    
    componentWillReceiveProps(nextProps){
        this.setState({
            isOpen: nextProps.isOpen
        })
    },
    getInitialState(){
        return {
            isOpen: this.props.isOpen
        }
    },
    open(){
        this.setState({
            isOpen:true
        });
    },
    close(){
        this.setState({
            isOpen:false
        });
        this.props.onClose();
    },
    render(){
        return null
    }
});

module.exports = Dialog;


/** WEBPACK FOOTER **
 ** ./script/cutil/Dialog.js
 **/